// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3rpOB","content":"styles_content__16Wjf","selectAll":"styles_selectAll__2OpXu"};